
import { api } from './api'
import type { CreateAlertRequest, PriceAlert } from '@catalyst-iq/shared';

// 1. הגדרת הטיפוס המורחב עבור הטוסטר (ההתראה + נתוני המניה מה-Join)


export type Alert = PriceAlert;

export const alertService = {
  async fetchAlerts(): Promise<Alert[]> {
    const response = await api.getAlerts();
    // אם השרת מחזיר אובייקט עם שדה alerts, או מערך ישירות
    return (response as any).alerts || (Array.isArray(response) ? response : []);
  },

  async createAlert(data: CreateAlertRequest): Promise<Alert> {
    try {
      const response = await api.createAlert(data);
      // מחזירים את ה-data מתוך התגובה (אם זה Axios) או את האובייקט עצמו
      return (response as any).data || response;
    } catch (error) {
      console.error('Service Error:', error);
      throw error; 
    }
  },

  async deleteAlert(id: string): Promise<void> {
    await api.cancelAlert(id);
  },
  
    
};
